import { createContext } from "react";

// The activity page resolves its presentation from the loaded people selection.
// Keep the window title in sync without a second directory request in the app shell.
export const ActivityPageContext = createContext<(personal: boolean) => void>(() => {});
